import { useQuery } from "@apollo/client/react";
import { GET_GROUPS } from "@/hooks";
import { CustomersType } from "@/types";

export const useGetGroups = (
  variables: { customerId?: string | number; customerName?: string } = {},
): { subsidiary: CustomersType[]; loading: boolean } => {
  const { customerId, customerName } = variables;
  const queryVariables = {
    customerId,
    customerName,
  };

  if (!customerId && !customerName) {
    queryVariables.customerName = "--none--";
  }

  const { data, loading } = useQuery<any>(GET_GROUPS, {
    variables: queryVariables,
  });

  return {
    subsidiary: data?.getGroups || [],
    loading,
  };
};
